<template>
	<div class="templatebody" :style="note">
		<div>
			<heard></heard>
		</div>
		<div class="text-white" style="margin: 10%0%3%0%;">
			<p style="margin-bottom: 1%;font-size: 20px;">恭喜您注册成为翊航迹服务商</p>
			<div class="flex-all-center">
				<p style="margin-bottom: 1%;font-size: 20px;">您的管理员账号为：</p>
				<p  style="margin-bottom: 1%;font-size: 20px;" class="text-orange">admin12345678910</p>
			</div>
			<p style="margin-bottom: 1%;font-size: 20px;">密码为：注册时填写的密码</p>
			<p style="margin-bottom: 1%;font-size: 20px;">请使用账号密码登录</p>
		</div>
		<div>
			<el-button class="text-white width-10" type="primary">
				<router-link to="/user/ordermanage"> 登录</router-link> <i class="el-icon-upload el-icon--right"></i>
			</el-button>
		</div>
		<div class="buttom-text">
			<p>版权所有：海南翊航翊信息科技有限责任公司 Copyright © 2014.Company name All rights reserved.</p>
		</div>
	</div>
</template>

<script>
import '@/assets/css/home.css'
import '@/assets/css/public.css'
import heard from '../public/heard.vue'
export default {
  name: 'Home',
  components: {
    heard
  },
  data () {
    return {
      textarea: '',
      note: {
        backgroundImage: 'url(' + require('../../assets/img/bg-login.jpg') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%'
      }
    }
  },
  mounted () {},
  methods: {}
}
</script>
<style>
	.el-button--primary {
		background-color: #FD9405;
		border-color: #FD9405;
		padding-left: 35px;
	}

	.el-button--primary:hover {
		background-color: #FD9405;
		border-color: #FD9405;
	}

	.el-button--primary:focus {
		background-color: #FD9405;
		border-color: #FD9405;
	}

	.el-form-item__label {
		font-size: 18px;
		color: #FFFFFF;
	}
</style>



// WEBPACK FOOTER //
// src/components/log/loginok.vue